import { render, staticRenderFns } from "./equiposCliente.vue?vue&type=template&id=8c67c22e&"
import script from "./equiposCliente.vue?vue&type=script&lang=js&"
export * from "./equiposCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports